import {
  loopbackGet, loopbackPost,
} from '..';
import {
  Certificate,
  DetailedEvaluation,
  Enrollment,
  Invoice,
  Payment,
  Trial,
  QuipUser,
  Survey,
  Submission,
  TrialTagMapping,
  DigitalSurvey,
  Institute,
} from '../../redux/types';

type TrialWithSurvey = Trial & {
  survey?: Survey;
}
type EnrollmentWithSubmission = Enrollment & {
  submission?: Submission;
}

type TrialFull = Trial & {
  digitalSurveys?: DigitalSurvey[];
  survey?: Survey;
  trialTagMapping?: TrialTagMapping[];
}

export type EnrollmentsFull = Enrollment & {
  certificate?: Certificate;
  trial: TrialFull;
  quipUser: QuipUser
  submission?: Submission;
};

export type EnrollmentWithInstitute = Enrollment & {
  institute: Institute
}

export const getEnrollmentById = (enrollmentId: number): Promise<Enrollment> => loopbackGet(`Enrollments/${enrollmentId}`);

export const getEnrollmentWithSubmission = (
  enrollmentId: number,
): Promise<EnrollmentWithSubmission> => {
  const promise = new Promise<EnrollmentWithSubmission>((resolve, reject) => {
    loopbackGet(`Enrollments/${enrollmentId}/getEnrollmentWithSubmission`).then((enrollment: EnrollmentWithSubmission[]) => {
      resolve(enrollment[0]);
    }, reject);
  });
  return promise;
};

export const getEnrollmentsByInstitute = (
  instituteId: number,
  year: number,
  query?: string,
  type?: string,
): Promise<EnrollmentsFull[]> => {
  const queryParam = query ? `&query=${query}` : '';
  const typeParam = type ? `&trialtype=${type}` : '';
  return loopbackGet(`Institutes/${instituteId}/getEnrollmentsFull?year=${year}${queryParam}${typeParam}`);
};

export const getEnrollmentsByIndividual = (
  userId: number,
  year: number,
  query?: string,
  type?: string,
): Promise<EnrollmentsFull[]> => {
  const queryParam = query ? `&query=${query}` : '';
  const typeParam = type ? `&trialtype=${type}` : '';
  return loopbackGet(`QuipUsers/${userId}/getEnrollmentsFull?year=${year}${queryParam}${typeParam}`);
};

export const getEnrollments = <T>(
  trialId: number, otherParams: unknown, otherFilters: unknown,
): Promise<T[]> => {
  const filter = { where: { trialId, ...otherParams as any }, ...otherFilters as any };
  const query = encodeURIComponent(JSON.stringify(filter));
  return loopbackGet(`Enrollments?filter=${query}`);
};

export const getEnrollmentsWithInstitute = (trialId: number): Promise<EnrollmentWithInstitute []> => loopbackGet(`Enrollments/${trialId}/getEnrollmentsWithInstitute`);

export const getTrialWithSurveyByEnrollmentId = async (
  enrollmentId: number,
): Promise<TrialWithSurvey> => {
  const uri = `Enrollments/${enrollmentId}/getTrialWithSurveyByEnrollmentId`;
  return loopbackGet(uri);
};

export const getDetailedEvaluation = (enrollmentId: number): Promise<DetailedEvaluation> => loopbackGet(`enrollments/${enrollmentId}/getEvaluationDetails`);

type EnrollmentWithInvoices = (Enrollment & { invoices: (Invoice & {payment: Payment})[] })
export const getEnrollmentWithInvoices = (enrollmentId: number): Promise<EnrollmentWithInvoices> => loopbackGet(`enrollments/${enrollmentId}/withInvoices`);

export const getCertificate = (enrollmentId: number): Promise<Certificate> => loopbackGet(
  `enrollments/${enrollmentId}/certificate`,
);

export const getUserEnrollmentByTrial = (trialId: number): Promise<Enrollment> => loopbackGet(`Enrollments/getUserEnrollmentByTrial?trialId=${trialId}`);

export const getInstituteEnrollmentByTrial = (trialId: number): Promise<Enrollment> => loopbackGet(`Enrollments/getInstituteEnrollmentByTrial?trialId=${trialId}`);

export const createMasterBookingList = (dateObject: Date):Promise<void> => loopbackPost('enrollments/createMasterBookingList', { date: dateObject });

export const nullifyDigitalGroundTruthGroupId = (gtGroupId: number): Promise<void> => loopbackGet(`Enrollments/nullifyDigitalGroundTruthGroupId?gtGroupId=${gtGroupId}`);
